// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"596":"404","822":"MapIndex"}[chunkId] + "." + {"596":"78ade40b","822":"8ec445c3"}[chunkId] + ".css";
};